module.exports = __webpack_public_path__ + "nonna_worried-fMd.png";